"use client";

import { useLocale } from "@calcom/lib/hooks/useLocale";
import classNames from "@calcom/ui/classNames";

const WIKI_BY_LOCALE: Record<string, string> = {
  ru: "https://wiki.knopka.click/ru/calendar/",
  en: "https://wiki.knopka.click/en/calendar/",
};

function wikiCalendarUrl(locale: string): string {
  const lang = (locale || "ru").split("-")[0]?.toLowerCase() || "ru";
  return WIKI_BY_LOCALE[lang] || WIKI_BY_LOCALE.ru;
}

function personalCalendarHref(): string {
  return "/bookings/upcoming";
}

export function KnopkaCalendarPromoFooter({ className }: { className?: string }) {
  const { t, i18n } = useLocale();
  const wikiUrl = wikiCalendarUrl(i18n.language || "ru");

  const openWiki = () => {
    window.open(wikiUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={classNames("w-full text-center text-sm", className)}>
      <span
        role="button"
        tabIndex={0}
        className="text-subtle border-subtle inline cursor-pointer border-b border-dashed pb-0.5"
        onClick={openWiki}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openWiki();
          }
        }}>
        {t("knopka_want_same_calendar_prefix")}
        <a
          href={personalCalendarHref()}
          className="text-brand font-medium hover:underline"
          onClick={(event) => event.stopPropagation()}>
          {t("knopka_calendar_brand")}
        </a>
      </span>
    </div>
  );
}
